export * from '@erp/ui/table';
